module.exports = __webpack_public_path__ + "components/forecast-table/static/energy-5b7a47bdf0e2d72271bc35e6edd43d9e.svg";